// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyState_wrapper__ngM1T","wrapper__message":"EmptyState_wrapper__message__gOBoR","wrapper__title":"EmptyState_wrapper__title__HvURp"};